import React from 'react';

import { MobileNavBar } from 'src/v2/components/layout/mobileNavBar';
import { Sidebar } from 'src/v2/components/layout/sidebar';

import { useIsMobile } from '~components/hooks/utils/useIsMobile';
import { useAppStateContext } from '~components/providers/AppStateProvider';

export const AppSidebar = () => {
  const { isApp } = useAppStateContext();
  const isMobile = useIsMobile();

  return isApp ? !isMobile ? <Sidebar /> : <MobileNavBar /> : null;
};
